import { colors, getRgbaColor, breakpoints } from '@web-for-marketing/react-ui';

export const searchDropdownStyles = {
    searchIconSvg: {
        '& path': {
            fill: colors.core.innovation,
        },
    },
    searchContainer: {
        width: '100vw',
        zIndex: -1,
        transform: 'translateY(0)',
        position: 'absolute',
        bottom: 0,
        right: 0,
        opacity: 0,
        transition: 'transform 300ms ease, z-index 300ms step-start, opacity 300ms ease',
        '&:before': {
            content: '""',
            width: 0,
            height: 0,
            borderLeft: '1.5rem solid transparent',
            borderRight: '1.5rem solid transparent',
            borderBottom: `1.5rem solid ${colors.core.geotab}`,
            marginTop: '-1.4rem',
            position: 'absolute',
            right: '4rem',
            transform: 'scaleY(0)',
            transition: 'transform 300ms ease 250ms',
            transformOrigin: 'bottom',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            '&:before': {
                borderBottom: `1.5rem solid ${colors.core.innovation}`,
            },
        },
        '@media (max-width: 374.9px)': {
            '&:before': {
                right: '3rem',
            },
        },
    },
    searchContent: (navHeight: number) =>
        (({
            width: '100%',
            padding: '0 20rem',
            background: `linear-gradient(90deg, ${colors.core.innovation} 0%, ${colors.core.geotab} 100%)`,

            '@media (max-width: 1200px)': {
                padding: '0 8rem',
            },

            [`@media (max-width: ${breakpoints.md})`]: {
                flexDirection: 'column',
                padding: '0 3rem',
                background: `linear-gradient(${colors.core.innovation} 0%, ${colors.core.geotab} 100%)`,
                height: `calc(100vh - ${navHeight}px)`,
                overflowY: 'scroll',
                justifyContent: 'space-between',
            },
        }) as const),
    showOpen: {
        zIndex: 900,
        opacity: 1,
        transform: 'translateY(100%)',
        transition: 'transform 300ms ease, z-index 300ms step-start 300ms, opacity 300ms ease',
        '&:before': {
            transform: 'scaleY(1)',
        },
    },
    searchBarContainer: {
        zIndex: 2,
        width: '60%',
        padding: '8rem 0',
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: 0,
            width: '100%',
            margin: '4rem 0',
        },
    },
    popularTopicsContainer: {
        zIndex: 2,
        width: '40%',
        padding: '8rem 0',
        paddingLeft: '6.4rem',
        '@media (max-width: 1200px)': {
            paddingLeft: '10rem',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: 0,
            width: '100%',
        },
    },
    searchText: {
        color: colors.core.snow,
        marginBottom: '2rem',
    },
    linkContainer: {
        marginBottom: '1.6rem',
        width: '50%',
        [`@media (max-width: ${breakpoints.md})`]: {
            width: '100%',
            marginBottom: '3.2rem',
        },
    },
    popularLink: {
        textDecoration: 'none',
        '&:hover > p': {
            fontWeight: 700,
        },
    },
    background: {
        display: 'block',
        transition:
            'z-index 300ms step-start 300ms, visibility 300ms ease 300ms, opacity 300ms ease 300ms, height 0ms ease 600ms',
        visibility: 'hidden !important' as 'hidden',
        opacity: 0,
        zIndex: -1,
        height: 0,
        width: '100%',
        backgroundColor: getRgbaColor(colors.core.deepSpace, 0.7),
        position: 'absolute',
        top: '100%',
        left: 0,
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'none !important',
        },
    },
    showBackground: {
        zIndex: 800,
        opacity: 1,
        visibility: 'visible !important' as 'visible',
        transition: 'z-index 300ms step-end 300ms, visibility 300ms ease 300ms, opacity 300ms ease 300ms',
        height: '100vh',
    },
    searchIcon: (shrink?: boolean) =>
        (({
            padding: '1rem',

            '& svg': {
                height: shrink ? '1.2rem' : '1.6rem',
                width: shrink ? '1.2rem' : '1.6rem',
                [`@media (max-width: ${breakpoints.md})`]: {
                    height: '2.3rem',
                    width: '2.3rem',
                },
            },
        }) as const),
    searchImage: {
        display: 'block',
        position: 'absolute',
        bottom: 0,
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'none',
        },
    },
    searchMobileImage: {
        display: 'none',
        [`@media (max-width: ${breakpoints.md})`]: {
            display: 'block',
            width: '100%',
        },
    },
} as const;
